import React from 'react';
import Icon from '../../../components/AppIcon';

const DataQualityWidget = ({ metrics }) => {
  const getQualityColor = (score) => {
    if (score >= 90) return 'text-success';
    if (score >= 70) return 'text-warning';
    return 'text-destructive';
  };

  const getQualityBgColor = (score) => {
    if (score >= 90) return 'bg-success/10';
    if (score >= 70) return 'bg-warning/10';
    return 'bg-destructive/10';
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-brand">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Data Quality Scores</h3>
        <Icon name="Shield" size={20} className="text-primary" />
      </div>
      <div className="space-y-4">
        {metrics?.map((metric, index) => (
          <div key={index} className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-foreground">{metric?.category}</span>
              <span className={`text-sm font-bold ${getQualityColor(metric?.score)}`}>
                {metric?.score}%
              </span>
            </div>
            <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
              <div 
                className={`h-full rounded-full transition-all duration-500 ${getQualityBgColor(metric?.score)}`}
                style={{ width: `${metric?.score}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DataQualityWidget;